/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerStartBatchMutationRequest, TransferBatchesControllerStartBatchMutationResponse, TransferBatchesControllerStartBatchPathParams, TransferBatchesControllerStartBatch400, TransferBatchesControllerStartBatch401, TransferBatchesControllerStartBatch403, TransferBatchesControllerStartBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerStartBatch";

function getTransferBatchesControllerStartBatchUrl(id: TransferBatchesControllerStartBatchPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/transfer-batches/${id}/start` as const }  
  return res
}

/**
 * @summary Start a transfer batch job
 * {@link /api/v1/transfer-batches/:id/start}
 */
export async function transferBatchesControllerStartBatch(id: TransferBatchesControllerStartBatchPathParams["id"], data?: TransferBatchesControllerStartBatchMutationRequest, config: Partial<RequestConfig<TransferBatchesControllerStartBatchMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferBatchesControllerStartBatchMutationResponse, ResponseErrorConfig<TransferBatchesControllerStartBatch400 | TransferBatchesControllerStartBatch401 | TransferBatchesControllerStartBatch403 | TransferBatchesControllerStartBatch404>, TransferBatchesControllerStartBatchMutationRequest>({ method : "POST", url : getTransferBatchesControllerStartBatchUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}